var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.218,
    height: 24.872,
    viewBox: "0 0 27.218 24.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M-677.036-3436.865q0-4.776,0-9.553c0-.079.021-.105.1-.12q1.92-.358,3.839-.722l4.581-.863,3.967-.748,2.262-.427c.089-.017.089-.016.089.076v2.317c0,.093,0,.093.1.093q4.962,0,9.924,0a1.284,1.284,0,0,1,.931.336,1.2,1.2,0,0,1,.382.837c0,.029,0,.058,0,.087q0,8.685,0,17.37a1.215,1.215,0,0,1-.943,1.22,1.379,1.379,0,0,1-.324.032h-9.945c-.139,0-.12-.015-.12.119q0,1.141,0,2.281c0,.1,0,.1-.1.086l-2.483-.468-3.667-.692-4.124-.777q-2.183-.411-4.367-.821c-.073-.013-.1-.036-.1-.114Q-677.035-3432.089-677.036-3436.865Z",
    transform: "translate(677.038 3449.305)",
    fill: "#1264a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M352.024-3191.043c.03-.019.013-.049.013-.072,0-.325,0-.649,0-.973,0-.068-.019-.082-.084-.082q-4.2,0-8.4,0c-.058,0-.133.025-.168-.01s-.012-.115-.012-.175q0-.693,0-1.387c.023-.02.051-.01.077-.01h8.488a.179.179,0,0,1,.079.006c.024-.008.014-.028.014-.043q0-.519,0-1.038c0-.014,0-.03-.011-.039h0c-.031,0-.062-.005-.093-.005h-8.455c-.1,0-.1,0-.1-.1,0-.448,0-.9,0-1.344,0-.071.013-.092.089-.092q4.238,0,8.477,0c.019,0,.039,0,.058,0s.038-.009.038-.037q0-.541,0-1.082c0-.005-.008-.01-.012-.015-.022.016-.047.009-.07.009h-8.507c-.022,0-.048.013-.066-.013q0-.741,0-1.482c0-.041.012-.058.053-.052a.512.512,0,0,0,.058,0h8.456c.094,0,.094,0,.094-.1,0-.317,0-.635,0-.952,0-.066-.016-.083-.083-.083q-4.232,0-8.463,0c-.116,0-.116,0-.116-.119v-1.359c0-.094,0-.094.1-.094h8.463c.1,0,.1,0,.1-.1,0-.317,0-.634,0-.952,0-.07-.022-.081-.085-.081q-4.228,0-8.456,0a.384.384,0,0,0-.058,0c-.051.007-.064-.013-.064-.064,0-.462,0-.925,0-1.387,0-.069.021-.081.084-.081q4.239,0,8.478,0c.1,0,.1,0,.1-.1,0-.319,0-.639,0-.959,0-.073-.021-.085-.088-.085q-4.239,0-8.478,0c-.1,0-.1,0-.1-.1,0-.475,0-.949,0-1.424,0-.058.016-.071.072-.071q5.074,0,10.148,0c.022,0,.043,0,.065,0,.02.02.01.046.01.069q0,8.844,0,17.688c0,.023.01.049-.01.069l-.087,0q-5.054,0-10.108,0c-.071,0-.092-.013-.091-.089,0-.537,0-1.075,0-1.612.024-.019.051-.01.077-.01h8.488A.183.183,0,0,1,352.024-3191.043Z",
    transform: "translate(-328.543 3210.691)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M-498.31-2893.872c-.007.076-.015.151-.021.227a9.865,9.865,0,0,1-.251,1.311q-.458,2.047-.918,4.094c-.011.047-.016.084-.083.079-.485-.039-.97-.074-1.455-.109a.072.072,0,0,1-.079-.069q-.393-1.894-.79-3.787-.347-1.659-.693-3.318c0-.007,0-.014,0-.025l.768-.058.535-.041c.1-.008.1-.009.115.086q.314,1.821.628,3.642c.082.477.178.951.237,1.432.02.161.025.323.038.485a.129.129,0,0,0,.014.073c.02-.007.018-.021.019-.031a7.139,7.139,0,0,1,.221-1.272q.508-2.248,1.016-4.5c.014-.062.034-.087.1-.091.362-.023.724-.052,1.086-.079.118-.009.237-.016.354-.028.055-.006.078.009.091.068q.547,2.559,1.1,5.117a7.807,7.807,0,0,1,.131.9c0,.022-.008.049.023.068.009-.114.016-.224.027-.333.054-.519.169-1.027.263-1.538q.4-2.164.8-4.326c.024-.129.023-.131.153-.14q.731-.054,1.463-.1c.047,0,.112-.036.137,0s-.012.091-.023.137l-1.217,5.022q-.37,1.527-.739,3.055c-.013.054-.031.074-.09.069-.359-.029-.719-.053-1.079-.08-.186-.013-.372-.028-.558-.039a.078.078,0,0,1-.086-.072q-.555-2.517-1.115-5.032a4.2,4.2,0,0,1-.09-.72c0-.024,0-.048,0-.071Z",
    transform: "translate(505.138 2904.194)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M1051.646-3189.051c0-.024,0-.048,0-.073v-17.68c0-.024,0-.049,0-.073a.054.054,0,0,1,.018.046c0,.024,0,.049,0,.073q0,8.795,0,17.589C1051.663-3189.13,1051.678-3189.087,1051.646-3189.051Z",
    transform: "translate(-1026.526 3210.399)",
    fill: "#19488e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 7.238,
    cy: 0.005,
    rx: 7.238,
    ry: 0.005,
    transform: "translate(12.741 3.495)",
    fill: "#1f4c91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 7.238,
    cy: 0.005,
    rx: 7.238,
    ry: 0.005,
    transform: "translate(12.742 21.367)",
    fill: "#1f4c91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 6.077,
    cy: 0.005,
    rx: 6.077,
    ry: 0.005,
    transform: "translate(13.082 5.123)",
    fill: "#1b498f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 6.077,
    cy: 0.005,
    rx: 6.077,
    ry: 0.005,
    transform: "translate(13.081 6.226)",
    fill: "#1f4c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M354.516-2912.59h-8.589v-.007h8.589Z",
    transform: "translate(-331.063 2920.396)",
    fill: "#1d4a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 6.076,
    cy: 0.004,
    rx: 6.076,
    ry: 0.004,
    transform: "translate(13.083 10.499)",
    fill: "#1e4b91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M344.082-2544.419h8.55c.031,0,.063,0,.094,0a.114.114,0,0,1-.083.016H344.17C344.14-2544.4,344.106-2544.39,344.082-2544.419Z",
    transform: "translate(-329.244 2557.567)",
    fill: "#19478e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M354.58-2360.164a.12.12,0,0,1-.083.017h-8.535v-.013h8.5c.039,0,.077,0,.116,0Z",
    transform: "translate(-331.096 2375.99)",
    fill: "#19478e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M352.69-2284.053l-.094,0h-8.55c.024-.023.054-.017.083-.017h8.484A.121.121,0,0,1,352.69-2284.053Z",
    transform: "translate(-329.209 2300.999)",
    fill: "#1d4a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 6.076,
    cy: 0.004,
    rx: 6.076,
    ry: 0.004,
    transform: "translate(13.083 18.534)",
    fill: "#19488e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M352.686-2098.069l-.094,0h-8.55c.024-.023.054-.017.083-.017h8.484A.121.121,0,0,1,352.686-2098.069Z",
    transform: "translate(-329.205 2117.718)",
    fill: "#1d4b90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/WordIcon.aa7ea7294dac4e7b5d2579b37e065a82.svg";
export { ForwardRef as ReactComponent };